// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'tiny... Remove this comment to see the full error message
import tinymce from 'tinymce';
import { CLOSE_MODAL_COMPLETE, INSERT_FILE, INSERT_VIDEO } from '../actions/ActionTypes';
import { openFileManager } from '../actions/FileManager';
import { openVideoPicker } from '../actions/Video';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../d... Remove this comment to see the full error message
import { resetAutocompleteAtomState } from '../data/autocompleteAtoms';
const disableEvent = event => {
  event.stopImmediatePropagation();
  event.preventDefault();
};
export const openModal = (editor, {
  onOpen,
  onClose = () => {},
  restoreSelection
}) => {
  // Prevent the editor from being blurred so that when focus shifts to the
  // modal, the editor isn't blurred
  editor.on('focusout', disableEvent, true);
  let selectionBookmark;
  if (restoreSelection) {
    // Capture the selection so that we can restore it after the modal
    // is closed
    selectionBookmark = editor.selection.getBookmark(1);
  }
  const onCloseModal = () => {
    tinymce.util.Delay.setEditorTimeout(editor, () => {
      editor.focus();
      if (selectionBookmark) {
        editor.selection.moveToBookmark(selectionBookmark);
      }
      editor.nodeChanged();
      onClose();
    });
    // Unbind events tied to the opening of this particular modal
    editor.off('focusout', disableEvent);
  };
  onOpen();
  editor.once(CLOSE_MODAL_COMPLETE, onCloseModal);
};
export const openFileManagerInpage = ({
  editor,
  callback,
  restoreSelection,
  onInsertEvent,
  fileType,
  initialPanel
}) => {
  const callbackHandler = evt => {
    callback(evt.action.file);
  };
  openModal(editor, {
    restoreSelection,
    onOpen() {
      editor.settings.bus.dispatchAction(openFileManager({
        type: fileType,
        initialPanel
      }));
      editor.once(onInsertEvent, callbackHandler);
    },
    onClose() {
      editor.off(onInsertEvent, callbackHandler);
      resetAutocompleteAtomState();
    }
  });
};
export const getOpenFilePickerInpage = editor => callback => {
  openFileManagerInpage({
    editor,
    callback,
    restoreSelection: false,
    onInsertEvent: INSERT_FILE,
    fileType: 'FILE'
  });
};
export const openVideoPickerInpage = ({
  editor,
  callback,
  restoreSelection
}) => {
  const callbackHandler = evt => {
    callback(evt.action.video);
  };
  openModal(editor, {
    restoreSelection,
    onOpen() {
      editor.settings.bus.dispatchAction(openVideoPicker());
      editor.once(INSERT_VIDEO, callbackHandler);
    },
    onClose() {
      editor.off(INSERT_VIDEO, callbackHandler);
    }
  });
};